import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useChatbot } from '@/feature/chatbot/useChatbot';
import { useTexts, useTranslation } from '@/feature/lang';
import EquipmentChips from '@/view/fleet/components/EquipmentChips';
import MiniButtonComponent from '../Button/MiniButton';
import Translate from '../Translate';
import NoWrap from '../Typography/NoWrap';

const ChipsContainer = styled('div', {
  name: 'Chatbot',
  slot: 'ChipsContainer',
})(({ theme }) => ({
  overflow: 'hidden',
  paddingRight: theme.spacing(0.5),
  flexShrink: 1,
}));

const ContrastMiniButton = styled(MiniButtonComponent, {
  name: 'Chatbot',
  slot: 'ContrastMiniButton',
})(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === 'light'
      ? 'rgba(255,255,255,0.5)'
      : 'rgba(0,0,0,0.5)',
}));

const ContrastTypography = styled(Typography, {
  name: 'Chatbot',
  slot: 'ContrastTypography',
})({ color: '#FFFFFF' });

export const ChatWindowTitle = () => {
  const texts = useTexts().component.chatbot;
  const { translate } = useTranslation();
  const { chatContext, conversation, createNew } = useChatbot();

  if (chatContext.equipmentMismatch) {
    const displayText = `${translate(texts.header.viewingMismatching)} ${
      chatContext.equipment?.displayName ?? ''
    }: ${conversation?.name}`;
    return (
      <>
        <ContrastTypography variant="body2" noWrap>
          {displayText}
        </ContrastTypography>
        <ContrastMiniButton onClick={createNew} variant="contained">
          <NoWrap>
            <Translate text={texts.actions.viewSelectedEquipment} />
          </NoWrap>
        </ContrastMiniButton>
      </>
    );
  }

  return (
    <>
      <ChipsContainer>
        <EquipmentChips names={[chatContext.equipment?.displayName]} />
      </ChipsContainer>
      <Typography variant="body2" noWrap sx={{ ml: 0, flexShrink: 5 }}>
        {conversation?.name}
      </Typography>
    </>
  );
};
